<!-- Menu header -->
<div class="navbar-header">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item me-auto d-flex">
      <!-- App Branding -->
      <a
        [routerLink]="['/']"
        class="navbar-brand">
        <span class="brand-logo">
          <img
            [src]="logoService.logoPath"
            alt="brand-logo"
            class="logo-expanded" />
          <img
            [src]="logoService.smallLogoPath"
            alt="brand-logo"
            class="logo-collapsed"
            width="40" />
        </span>
      </a>
    </li>

    <!-- Menu Toggler -->
    <li class="nav-item nav-toggle">
      <a
        (click)="toggleSidebarCollapsible()"
        class="nav-link modern-nav-toggle d-none d-xl-block pe-0">
        <love-it-generic-icon
          [selector]="isCollapsed ? 'bi-pin-angle' : 'bi-pin-angle-fill'"
          class="toggle-icon collapse-toggle-icon"></love-it-generic-icon>
      </a>
      <a
        (click)="toggleSidebar()"
        class="nav-link modern-nav-toggle d-block d-xl-none pe-0">
        <i
          class="font-medium-4 text-primary toggle-icon"
          data-feather="x"></i>
      </a>
    </li>
  </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div
  [ngClass]="{ 'd-block': isScrolled }"
  class="shadow-bottom"></div>

<!-- Main menu -->
<div
  (scroll)="onSidebarScroll()"
  [perfectScrollbar]
  class="main-menu-content">
  <ul
    class="navigation navigation-main"
    core-menu
    layout="vertical"></ul>
</div>
<!--/ Main menu -->
